import { Injectable } from "@angular/core";
import { HttpRequestService } from "./http-request.service";

@Injectable()
export class ChatbotHttpRequestService extends HttpRequestService {

  override resolveMasterUrl(url: string): string {
    return this.appConfig.config.ChatbotAPIUrl + url;
  }
}
